/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MasteryCriteriaModel } from '../../models/mastery-criteria-model';

export interface RemoveCustomMasteryCriteria$Params {
      body?: MasteryCriteriaModel
}

export function RemoveCustomMasteryCriteria(http: HttpClient, rootUrl: string, params?: RemoveCustomMasteryCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, RemoveCustomMasteryCriteria.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

RemoveCustomMasteryCriteria.PATH = '/api/Supervisor/RemoveCustomMasteryCriteria';
